import Vue from 'vue';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueYoutube from 'vue-youtube'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpotify, faFacebookSquare, faInstagram, faTwitter, faTwitterSquare, faYoutubeSquare, faGoogle, faYoutube, faWhatsapp, faLine, faTelegram, faGooglePlusG, faLinkedin, faTiktok  } from '@fortawesome/free-brands-svg-icons'
import { faUserSecret, faDownload, faGlobeAmericas, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueNumber from 'vue-number-animation'
import i18n, { applyI18nLocale } from '@/plugins/i18n';
import { detectInitialLanguage, applyLanguage } from '@/utils/languageDetection';
import VueGtag from "vue-gtag";
import VueLazyload from 'vue-lazyload';
import VueMeta from 'vue-meta'
import axios from 'axios'
import Router from 'vue-router'

Vue.prototype.$http = axios

library.add(faUserSecret, faDownload, faGlobeAmericas, faInstagram, faFacebookSquare, faEnvelope, faTwitter, faTwitterSquare, faYoutubeSquare, faGoogle, faLinkedin, faYoutube, faSpotify, faTiktok)
 
Vue.component('font-awesome-icon', FontAwesomeIcon)

var VueScrollTo = require('vue-scrollto');

// Vue.use(VueLazyload, {
//   error: './assets/img/loading.gif',
//   loading: './assets/img/loading.gif',
//   lazyComponent: true,
//   attempt: 1,
//   preLoad: 1.3,
//   listenEvents: [ 'scroll' ]
// })

Vue.use(VueMeta)
Vue.use(VueLazyload, {
  observer: true,
})
Vue.use(VueNumber) 
Vue.use(VueScrollTo)
Vue.use(VueYoutube)
Vue.use(Router)

import App from './App.vue';

// Vue.use(BootstrapVue)
Vue.config.productionTip = false;

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      component: App,
    },
    {
      path: '/post',
      component: App,
      alias: '/post/'
    }
  ]
});
Vue.use(VueGtag, {
  config: {
    id: 'G-EPR7S0WWKV'
  }
})

// Delay app mount until language detection completes (non-blocking UI: we still render quickly)
// We first create a placeholder mount after detection; detection uses IP (with timeout) then browser fallback.

detectInitialLanguage((lang) => {
  // map lowercase to i18n uppercase
  applyI18nLocale(lang);
  applyLanguage(lang); // set html attributes
}).finally(() => {
  new Vue({
    router: router,
    i18n,
    render: h => h(App),
  }).$mount('#app');
});


